import type { ICategoryGroup } from '@/store/organization/categoryGroupSlice';
import type { IKeywordGroup } from '@/store/organization/keywordGroupSlice';

export default (
  selectedKeywordsAndCategoryGroups: string[],
  keywordGroups: IKeywordGroup[],
  categoryGroups: ICategoryGroup[]
) => {
  const actualKeywordsGroupsIds = selectedKeywordsAndCategoryGroups
    .filter((group) => group.startsWith('kg'))
    .map((group) => group.split('-')[1] as string);

  const actualCategoryGroupsIds = selectedKeywordsAndCategoryGroups
    .filter((group) => group.startsWith('cg'))
    .map((group) => group.split('-')[1] as string);

  const actualKeywordsGroups = actualKeywordsGroupsIds.map((id) =>
    keywordGroups.find(({ id: keywordGroupId }) => +keywordGroupId === +id)
  );

  const actualCategoryGroups = actualCategoryGroupsIds.map((id) =>
    categoryGroups.find(({ id: categoryGroupId }) => +categoryGroupId === +id)
  );

  const actualKeywords: string[] = actualKeywordsGroups.reduce(
    (acc: string[], value) => [
      ...acc,
      ...(value?.keywords.map(({ keyword }) => `k-${keyword}`) ?? []),
    ],
    []
  );

  const actualCategories: string[] = actualCategoryGroups.reduce(
    (acc: string[], value) => [
      ...acc,
      ...(value?.categories.map(({ category }) => `c-${category}`) ?? []),
    ],
    []
  );

  const result = [...actualKeywords, ...actualCategories];

  return result;
};
